import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/styles/animations.css';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import LinearProgress from '@mui/material/LinearProgress';
import { setupAnimationObservers } from './utils/animationObserver';

// Add a 'js' class to the document body to indicate JS is available
// This helps conditionally apply animations
if (typeof document !== 'undefined') {
  document.body.classList.add('js');
}

function Main() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulating a delay to showcase loading indicator
    const timer = setTimeout(() => {
      setLoading(false); // Set loading to false after some delay
      
      // Setup animation observers after the app has loaded
      setTimeout(() => {
        setupAnimationObservers();
      }, 100); // Small delay to ensure DOM is fully rendered
    }, 500); // Simulate 0.5 seconds loading time

    // Clean up timer on component unmount
    return () => clearTimeout(timer);
  }, []);

  return (
    <React.StrictMode>
      {loading ? (
        <LinearProgress />
      ) : (
        <App />
      )}
    </React.StrictMode>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Main />);

reportWebVitals();

// Add a notification about video thumbnails
if (process.env.NODE_ENV === 'development') {
  // Check if the thumbnails directory exists
  fetch('/thumbnails/README.txt')
    .then(response => {
      if (!response.ok) {
        console.info(
          '%c Video Optimization 📹',
          'background: #3b82f6; color: white; padding: 2px 4px; border-radius: 4px; font-weight: bold;',
          '\nTo improve performance, videos are loaded only when played.\n' +
          'Thumbnails are generated automatically if needed.\n' +
          'To pre-generate thumbnails run: npm run generate-thumbnails'
        );
      }
    })
    .catch(() => {
      // This will happen if the thumbnails directory doesn't exist
      console.info(
        '%c Video Optimization 📹',
        'background: #3b82f6; color: white; padding: 2px 4px; border-radius: 4px; font-weight: bold;',
        '\nThumbails directory not found. Videos will be optimized with dynamically generated thumbnails.\n' +
        'To pre-generate thumbnails run: npm run generate-thumbnails'
      );
    });
}
